var React = require('react');

function LogoWhiteOmg (props) {
    return React.createElement("svg",props,[React.createElement("path",{"fill":"#fff","fillRule":"nonzero","d":"M13.868 69.312H.173V.763h4.54v64.082h9.155v4.467z","key":0}),React.createElement("ellipse",{"cx":"806.115","cy":"665.987","fill":"none","stroke":"#fff","strokeWidth":"43.41","rx":"119.236","ry":"116.178","transform":"matrix(.09215 0 0 .09215 -48.636 5.714)","key":1}),React.createElement("path",{"fill":"#fff","fillRule":"nonzero","d":"M13.4 34.77V.858h24.533v4.026H17.9v10.373h18.756v3.978H17.899v11.557H38.69v3.978H13.4z","key":2}),React.createElement("path",{"fill":"#fff","d":"M13.293 42.06h25.452v4.033H13.293z","key":3})]);
}

LogoWhiteOmg.defaultProps = {"fillRule":"evenodd","strokeLinecap":"round","strokeLinejoin":"round","strokeMiterlimit":"1.5","clipRule":"evenodd","viewBox":"0 0 39 80"};

module.exports = LogoWhiteOmg;

LogoWhiteOmg.default = LogoWhiteOmg;
